import { useState, useEffect } from "react";
import { useLang } from "@/context/LanguageContext";
import translations from "@/data/translations";
import { MessageCircle } from "lucide-react";

const WHATSAPP_URL = "https://wa.me/34672808030";

const StickyMobileCTA = () => {
  const { lang } = useLang();
  const t = translations[lang].nav;
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;

  return (
    <div data-testid="sticky-mobile-cta" className="sticky-mobile-cta md:hidden">
      <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center justify-center gap-2 w-full bg-electric text-white font-semibold py-3.5 rounded-full hover:bg-electric-hover transition-all shadow-lg shadow-electric/25 text-sm"
      >
        <MessageCircle size={18} />
        {t.cta}
      </a>
    </div>
  );
};

export default StickyMobileCTA;
